'use strict';

define('routing/router',['grapnel', 'knockout'], function (Grapnel, ko) {

	function Router() {
		var root = '';
		this._grapnel = new Grapnel({ root: root, pushState: true });
		this.component = ko.observable(null);
		this.root = root;
		this._paramNames = [];
		this.maps = [];
	}

	Router.prototype.addParams = function (paramNames) {
		paramNames.forEach(function (paramName) {
			if (paramName in this) {
				throw new Error('reserved parameter name');
			} else {
				this[paramName] = ko.observable(null);
			}
		}.bind(this));

		this._paramNames.push.apply(this._paramNames, paramNames);
	};

	Router.prototype.remap = function (maps) {
		this.maps.unshift.apply(this.maps, maps);
		var root = '';
		this._grapnel = new Grapnel({ root: root, pushState: true });
		this.maps.forEach(function (map) {
			this._mapRoute(map);
		}.bind(this));
		this._mapRoute({ path: /.*/, componentName: null });
	};

	Router.prototype.map = function (maps) {
		this.maps.push.apply(this.maps, maps);
		this.maps.forEach(function (map) {
			this._mapRoute(map);
		}.bind(this));
		this._mapRoute({ path: /.*/, componentName: null });
	};

	Router.prototype.navigate = function () {
		this._grapnel.navigate.apply(this._grapnel, arguments);
	};

	Router.prototype.add = function () {
		this._grapnel.add.apply(this._grapnel, arguments);
	};

	Router.prototype._mapRoute = function (map) {
		this._grapnel.add(map.path, function mapRouteHandler(req, event) {
			if (typeof map.constraint !== 'function' || map.constraint(event.value)) {

				this._paramNames.forEach(function (paramName) {
					var value = req.params[paramName];
					if (typeof value !== 'undefined') {
						this[paramName](value);
					} else {
						this[paramName](null);
					}
				}.bind(this));

				this.component(map.componentName);
				event.stopPropagation();
			}
		}.bind(this));
	};

	return new Router();
});
